import chooser from './components/chooser/reducer'
import purchase from './components/purchaseLightBox/reducer'
import addUsersCard from './components/licenseList/addUsers/reducer'
import creditCard from './components/creditCard/reducer'
import common from './reducer'
import {combineReducers} from 'redux'

export default (initAppData) => combineReducers({
    common,
    chooser,
    addUsersCard,
    purchase,
    creditCard,
})


// WEBPACK FOOTER //
// ./web/js/administration/licenses/licenseReducer.js